import { Box, Grid, Paper, Typography } from '@mui/material';
import React, { FC } from 'react';
import { OrderProperty } from 'types/order';

import { CreateLoanModal } from './components/create-loan-modal';
import { EscrowAmounts } from './components/escrow-amounts';
import { Header } from './components/header';
import { LoanContent } from './components/loan-content';
import { LendersSection } from './components/lenders-section';
import { useLoansHooks } from './hooks';
import { useStyles } from './styles';
import { Link } from 'react-router-dom';

type Props = {
  properties: OrderProperty[],
  orderType: string
}

export const Loans: FC<Props> = ({
  properties,
  orderType
}) => {
  const classes = useStyles();

  const {
    loans,
    onSelectLoan,
    selectedLoan,
    loanForm,
    setModalData,
    modalData,
    onDeleteLoanInterest,
    isDeleteInterestLoading,
    onDeleteLoan,
    isDeleteLoanLoading,
    onSave,
    isUpdateLoanLoading,
    isLoansLoading,
    isLoansError,
    orderAccountingEscrowEntries,
    deleteAdditional,
    isDeleteAdditionalLoading,
    onClose,
    t,
    parties
  } = useLoansHooks();

  return (
    <div className={classes.rootContainer}>
      <Grid container spacing={2} className={classes.topRow}>
        {orderAccountingEscrowEntries.length > 0 && (
          <Grid item xs={12} md={6}>
            <Paper className={classes.escrowAmountsContainer}>
              <EscrowAmounts
                orderAccountingEscrowEntries={orderAccountingEscrowEntries}
                parties={parties || []}
              />
            </Paper>
          </Grid>
        )}
        <Grid item xs={12} md={orderAccountingEscrowEntries.length > 0 ? 6 : 12}>
          <LendersSection
            parties={parties || []}
            isLoading={isLoansLoading}
            hasError={isLoansError}
          />
        </Grid>
      </Grid>

      <Paper>
        <>
          <Header
            loans={loans}
            isDataLoading={isLoansLoading}
            selectedLoan={selectedLoan}
            onSelectLoan={onSelectLoan}
            setModalData={setModalData}
            t={t}
          />

          {loans.length > 0 ? (
            <LoanContent
              isLoansLoading={isLoansLoading}
              isUpdateLoanLoading={isUpdateLoanLoading}
              selectedLoan={selectedLoan}
              loanForm={loanForm}
              setModalData={setModalData}
              isDeleteInterestLoading={isDeleteInterestLoading}
              isDeleteLoanLoading={isDeleteLoanLoading}
              modalData={modalData}
              onCloseModal={onClose}
              onDeleteLoan={onDeleteLoan}
              onDeleteLoanInterest={onDeleteLoanInterest}
              onSave={onSave}
              deleteAdditional={deleteAdditional}
              isDeleteAdditionalLoading={isDeleteAdditionalLoading}
              orderType={orderType}
            />
          ) : (
            <Box className={classes.noLoansContent}>
              <Typography variant="h6" className={classes.noLoansText}>
                {t('loan:noLoansYet')}
              </Typography>
            </Box>
          )}
        </>
      </Paper>
      {modalData?.modal === 'createLoan' && (
        <CreateLoanModal
          onClose={onClose}
          properties={properties}
        />
      )}
    </div>
  );
};
